import React from "react";
import { useMutation } from "react-query";
import { resetPassword } from "./gateway";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { queryClient } from "src/shared/services/QeuryClient/reactQueryClient";
import { USER_DATA_INFO_QUERY_KEY } from "src/shared/enums/useQueryKeys";
import { useAuth } from "src/shared/context/useAuth";

export default function useResetPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userHomePath } = useAuth();

  return useMutation({
    mutationFn: resetPassword,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [USER_DATA_INFO_QUERY_KEY],
        exact: false,
      });
      enqueueSnackbar(t("Επιτυχής αλλαγή κωδικού πρόσβασης"), {
        variant: "success",
      });

      navigate(userHomePath);
    },
  });
}
